

























































































import { Vue, Component } from "vue-property-decorator";
import { mapState } from "vuex";

import PrivacyPolicy from "@/components/PrivacyPolicy.vue";
import Webhook from "@/components/Webhook.vue";

@Component({
  components: {
    PrivacyPolicy,
    Webhook
  },
  computed: mapState(["workMinutes", "shortBreakMinutes", "longBreakMinutes"])
})
export default class Menu extends Vue {
  private isShown = false;

  private workMinutes!: number;
  private shortBreakMinutes!: number;
  private longBreakMinutes!: number;

  private toggleMenu() {
    this.isShown = !this.isShown;
  }

  private updateWorkMinutes(event: Event) {
    this.$store.dispatch(
      "updateWorkMinutes",
      Number((event.target as HTMLInputElement).value)
    );
  }

  private updateShortBreakMinutes(event: Event) {
    this.$store.dispatch(
      "updateShortBreakMinutes",
      Number((event.target as HTMLInputElement).value)
    );
  }

  private updateLongBreakMinutes(event: Event) {
    this.$store.dispatch(
      "updateLongBreakMinutes",
      Number((event.target as HTMLInputElement).value)
    );
  }

  private resetSettings() {
    if (!window.confirm("Do you really want to reset ?")) {
      return;
    }
    this.$ga.event("setting", "click", "default");
    this.$store.dispatch("resetTimerSettings");
  }
}
